import React, { useEffect, useState } from 'react';
import { UserPlus, Zap, Lock, HelpCircle, X, ChevronDown, QrCode, Palette, Search, Wrench } from 'lucide-react';
import { PublicHeader } from './PublicHeader';
import { useNavigate, useParams } from 'react-router-dom';
// Define user profiles data
const userProfiles = {
  'giulia-verdi': {
    name: 'Giulia Verdi',
    role: 'Web Developer',
    location: 'Rome',
    match: '92%',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gou2Ede34nLvCQizNZLz4q/irene-strong--FOUPtqP-mY-unsplash.jpg',
    skills: {
      designSkills: [{
        name: 'Frontend Development',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'JavaScript',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Responsive Design',
        level: '85%',
        expertise: 'Advanced'
      }],
      researchStrategy: [{
        name: 'Code Review',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Testing',
        level: '80%',
        expertise: 'Advanced'
      }, {
        name: 'Agile Methodology',
        level: '75%',
        expertise: 'Advanced'
      }],
      toolsTechnologies: [{
        name: 'React',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Node.js',
        level: '80%',
        expertise: 'Advanced'
      }, {
        name: 'Git',
        level: '90%',
        expertise: 'Expert'
      }]
    },
    impact: '92%',
    experience: '5+ years of experience in web development, specialized in frontend and React applications.',
    aiSuggestions: [{
      emoji: '💻',
      title: 'Development Collaboration',
      description: "Giulia's web development skills align perfectly with frontend development projects.",
      tags: ['Frontend', 'React']
    }, {
      emoji: '🚀',
      title: 'Code Review',
      description: 'With 5 years of experience, Giulia can offer valuable code reviews to improve quality.',
      tags: ['Code Quality', 'Mentorship']
    }],
    collaborations: [{
      role: 'UX/UI Designer',
      match: '95%',
      description: 'Can transform your designs into functional code'
    }, {
      role: 'Backend Developer',
      match: '92%',
      description: 'Ideal for full-stack projects with complex APIs'
    }, {
      role: 'Project Manager',
      match: '88%',
      description: 'Perfect for coordinating web development projects'
    }]
  },
  'roberto-neri': {
    name: 'Roberto Neri',
    role: 'Marketing',
    location: 'Milan',
    match: '78%',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/37RNAboQN8qk3BnTK1YzhT/irene-strong-TMt3JGoVlng-unsplash.jpg',
    skills: {
      designSkills: [{
        name: 'Digital Marketing',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Social Media',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Content Strategy',
        level: '85%',
        expertise: 'Advanced'
      }],
      researchStrategy: [{
        name: 'Market Research',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Analytics',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Campaign Planning',
        level: '80%',
        expertise: 'Advanced'
      }],
      toolsTechnologies: [{
        name: 'Google Analytics',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Meta Ads',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Mailchimp',
        level: '80%',
        expertise: 'Advanced'
      }]
    },
    impact: '78%',
    experience: '6+ years of experience in digital marketing, focusing on content strategies and social media.',
    aiSuggestions: [{
      emoji: '📱',
      title: 'Social Media Strategies',
      description: 'Roberto can help develop effective content strategies to increase engagement.',
      tags: ['Social Media', 'Content']
    }, {
      emoji: '📊',
      title: 'Market Analysis',
      description: "Roberto's analytical skills can help identify new market opportunities.",
      tags: ['Analytics', 'Strategy']
    }],
    collaborations: [{
      role: 'Graphic Designer',
      match: '94%',
      description: 'Ideal for creating impactful visual content for campaigns'
    }, {
      role: 'Content Writer',
      match: '91%',
      description: 'Perfect for developing effective marketing messages'
    }, {
      role: 'Web Developer',
      match: '85%',
      description: 'Useful for implementing integrated digital campaigns'
    }]
  },
  'marco-bianchi': {
    name: 'Marco Bianchi',
    role: 'UX Designer',
    location: 'Rome',
    match: '85%',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rpDp7vdFb4PQ6LshFeTqC4/christian-buehner-zYD6ou1Qj10-unsplash.jpg',
    skills: {
      designSkills: [{
        name: 'UX Design',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Wireframing',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Prototyping',
        level: '85%',
        expertise: 'Advanced'
      }],
      researchStrategy: [{
        name: 'User Research',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Usability Testing',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Information Architecture',
        level: '80%',
        expertise: 'Advanced'
      }],
      toolsTechnologies: [{
        name: 'Figma',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Adobe XD',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Sketch',
        level: '80%',
        expertise: 'Advanced'
      }]
    },
    impact: '85%',
    experience: '4+ years of experience in UX design, specialized in user research and interface design.',
    aiSuggestions: [{
      emoji: '🎨',
      title: 'Design System',
      description: 'Marco can help create a consistent design system to improve team efficiency.',
      tags: ['Design Systems', 'UI']
    }, {
      emoji: '🔍',
      title: 'User Research',
      description: "Marco's skills in user research can help better understand your customers.",
      tags: ['User Research', 'UX']
    }],
    collaborations: [{
      role: 'Frontend Developer',
      match: '96%',
      description: 'Ideal for transforming designs into functional interfaces'
    }, {
      role: 'Product Manager',
      match: '93%',
      description: 'Perfect for aligning design with product goals'
    }, {
      role: 'Content Strategist',
      match: '87%',
      description: 'Useful for creating user experiences with effective content'
    }]
  },
  'laura-rossi': {
    name: 'Laura Rossi',
    role: 'Product Manager',
    location: 'Florence',
    match: '90%',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iiGCarC4BpomqUoZERcuSH/jurica-koletic-7YVZYZeITc8-unsplash.jpg',
    skills: {
      designSkills: [{
        name: 'Product Strategy',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Roadmapping',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'User Stories',
        level: '85%',
        expertise: 'Advanced'
      }],
      researchStrategy: [{
        name: 'Market Analysis',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Competitive Research',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'User Feedback',
        level: '80%',
        expertise: 'Advanced'
      }],
      toolsTechnologies: [{
        name: 'Jira',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Trello',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Amplitude',
        level: '80%',
        expertise: 'Advanced'
      }]
    },
    impact: '90%',
    experience: '7+ years of experience in product management, focusing on digital products and growth strategies.',
    aiSuggestions: [{
      emoji: '📈',
      title: 'Product Strategy',
      description: 'Laura can help define an effective product roadmap aligned with business goals.',
      tags: ['Strategy', 'Growth']
    }, {
      emoji: '🔄',
      title: 'Agile Processes',
      description: "Laura's skills in Agile processes can improve your team's efficiency.",
      tags: ['Agile', 'Process']
    }],
    collaborations: [{
      role: 'UX Designer',
      match: '95%',
      description: 'Ideal for aligning design with product goals'
    }, {
      role: 'Software Engineer',
      match: '92%',
      description: 'Perfect for translating requirements into technical features'
    }, {
      role: 'Data Analyst',
      match: '89%',
      description: 'Useful for making data-driven decisions'
    }]
  },
  'andrea-marino': {
    name: 'Andrea Marino',
    role: 'Data Scientist',
    location: 'Turin',
    match: '82%',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bc8MUYcKAT6QrAiyMeUwXx/christian-buehner-DItYlc26zVI-unsplash.jpg',
    skills: {
      designSkills: [{
        name: 'Data Analysis',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Machine Learning',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Statistical Modeling',
        level: '85%',
        expertise: 'Advanced'
      }],
      researchStrategy: [{
        name: 'Hypothesis Testing',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'A/B Testing',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'Data Visualization',
        level: '80%',
        expertise: 'Advanced'
      }],
      toolsTechnologies: [{
        name: 'Python',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'R',
        level: '85%',
        expertise: 'Advanced'
      }, {
        name: 'SQL',
        level: '90%',
        expertise: 'Expert'
      }]
    },
    impact: '82%',
    experience: '5+ years of experience in data science, specialized in predictive analysis and machine learning.',
    aiSuggestions: [{
      emoji: '📊',
      title: 'Data Analysis',
      description: 'Andrea can help extract meaningful insights from your data to guide business decisions.',
      tags: ['Data Analysis', 'Insights']
    }, {
      emoji: '🤖',
      title: 'Machine Learning',
      description: "Andrea's ML skills can help implement innovative predictive solutions.",
      tags: ['ML', 'AI']
    }],
    collaborations: [{
      role: 'Product Manager',
      match: '94%',
      description: 'Ideal for data-driven product decisions'
    }, {
      role: 'Backend Developer',
      match: '91%',
      description: 'Perfect for implementing complex algorithms'
    }, {
      role: 'UX Researcher',
      match: '86%',
      description: 'Useful for analyzing user behavioral data'
    }]
  },
  'sophia-rossi': {
    name: 'Sophia Rossi',
    role: 'UX/UI Designer',
    location: 'Rome',
    match: '85%',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/woFngADa1aU2Q5MqNXmffj/pexels-olly-774909.jpg',
    skills: {
      designSkills: [{
        name: 'UX/UI Design',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Wireframing',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Interaction Design',
        level: '85%',
        expertise: 'Advanced'
      }],
      researchStrategy: [{
        name: 'User Research',
        level: '80%',
        expertise: 'Advanced'
      }, {
        name: 'Prototyping',
        level: '90%',
        expertise: 'Expert'
      }, {
        name: 'Design Thinking',
        level: '75%',
        expertise: 'Advanced'
      }],
      toolsTechnologies: [{
        name: 'Figma',
        level: '95%',
        expertise: 'Expert'
      }, {
        name: 'Adobe XD',
        level: '80%',
        expertise: 'Advanced'
      }, {
        name: 'HTML/CSS',
        level: '60%',
        expertise: 'Intermediate'
      }]
    },
    impact: '85%',
    experience: '7+ years of experience in product design, with a particular focus on user-centered digital experiences.',
    aiSuggestions: [{
      emoji: '💻',
      title: 'UX/UI Collaboration',
      description: "Sophia's UX/UI design skills align perfectly with web and mobile development projects.",
      tags: ['Product Design', 'App Development']
    }, {
      emoji: '🚀',
      title: 'Mentorship',
      description: 'With 7 years of industry experience, Sophia can offer mentorship to junior designers.',
      tags: ['Knowledge Sharing', 'Career Growth']
    }],
    collaborations: [{
      role: 'Frontend Developer',
      match: '95%',
      description: 'Can transform your designs into functional code'
    }, {
      role: 'Product Manager',
      match: '92%',
      description: 'Ideal for transforming designs into product strategies'
    }, {
      role: 'Content Strategist',
      match: '88%',
      description: 'Perfect for projects requiring effective UX writing'
    }]
  }
};
export function PublicProfilePage() {
  const navigate = useNavigate();
  const {
    username
  } = useParams();
  const [showImpactDetails, setShowImpactDetails] = useState(false);
  const [showImpactModal, setShowImpactModal] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    designSkills: false,
    researchStrategy: false,
    toolsTechnologies: false
  });
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    // Find the user data based on the URL parameter
    if (username && userProfiles[username]) {
      setUserData(userProfiles[username]);
    } else {
      // Default to Sophia's profile if user not found
      setUserData(userProfiles['sophia-rossi']);
    }
  }, [username]);
  const handleHeaderClick = () => {
    navigate('/');
  };
  const toggleSection = section => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };
  const closeImpactModal = () => {
    setShowImpactModal(false);
  };
  const openQrModal = () => {
    setShowQrModal(true);
  };
  const closeQrModal = () => {
    setShowQrModal(false);
  };
  // If user data is not loaded yet, show a loading state
  if (!userData) {
    return <div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] bg-white text-black font-sans flex items-center justify-center h-screen" data-id="element-2640">
        <div className="text-center" data-id="element-2641">
          <div className="w-12 h-12 border-4 border-black border-t-transparent rounded-full animate-spin mx-auto mb-4" data-id="element-2642"></div>
          <p className="text-lg" data-id="element-2643">Loading profile...</p>
        </div>
      </div>;
  }
  return <div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] bg-white text-black font-sans" data-id="element-2644">
      {/* Scrollable content */}
      <div className="overflow-y-auto" data-id="element-2645">
        {/* Hero section */}
        <section className="bg-black text-white pt-4 pb-10 px-6" data-id="element-2646">
          <div className="logo-wrapper origin-left cursor-pointer" onClick={handleHeaderClick} data-id="element-2647">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1JuVByZ98RTQ1Zt83kwhSA/The_Social_Hub_idqwy7vsH3_1.svg" alt="The Social Hub" className="h-16 brightness-0 invert" data-id="element-2648" />
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-2649">
            {/* Profile info and CTA */}
            <div className="flex flex-col items-center text-center" data-id="element-2650">
              <div className="mb-6 relative" data-id="element-2651">
                <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-gray-200" data-id="element-2652">
                  <img src={userData.image} alt={userData.name} className="w-full h-full object-cover" data-id="element-2653" />
                </div>
                {/* QR Code - Small button in bottom right of profile picture */}
                <div className="absolute bottom-0 right-0 p-1 bg-white rounded-full cursor-pointer shadow-md hover:bg-gray-100 transition-colors" onClick={openQrModal} data-id="element-2654">
                  <QrCode className="w-5 h-5 text-black" data-id="element-2655" />
                </div>
              </div>
              <h1 className="text-2xl font-light mb-1 font-sharp-grotesk" data-id="element-2656">
                {userData.name}
              </h1>
              <p className="text-gray-400 font-medium mb-3" data-id="element-2657">
                {userData.role} • {userData.location}
              </p>
              <button className="bg-white text-black border border-black px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-colors" data-id="element-2658">
                <UserPlus className="w-4 h-4 inline-block mr-2" data-id="element-2659" />
                Connect
              </button>
            </div>
          </div>
        </section>
        {/* Community Impact */}
        <section className="px-6 py-6 border-b border-gray-200" data-id="element-2660">
          <h2 className="text-xl font-sharp-grotesk mb-4" data-id="element-2661">Community Impact</h2>
          <div className="bg-white rounded-lg p-0" data-id="element-2662">
            <div className="flex items-center" data-id="element-2663">
              <div className="w-32 h-32 flex flex-col items-center justify-center mr-5 relative" data-id="element-2664">
                <div className="relative w-full h-full flex items-center justify-center" data-id="element-2665">
                  <div className="flex flex-col items-center justify-center" data-id="element-2666">
                    <p className="text-2xl font-light font-sharp-grotesk text-black" data-id="element-2667">
                      {userData.impact}
                    </p>
                    <p className="text-xs text-gray-500 mt-0.5 text-center" data-id="element-2668">
                      impact index
                    </p>
                    <p className="text-base mt-1" data-id="element-2669">⭐⭐⭐</p>
                  </div>
                </div>
              </div>
              <div className="h-16 border-l border-gray-200 mr-5" data-id="element-2670"></div>
              <div className="flex-1" data-id="element-2671">
                <div className="mb-1" data-id="element-2672">
                  <h3 className="text-base font-medium" data-id="element-2673">Significant Impact</h3>
                </div>
                <p className="text-sm text-gray-600 mb-2" data-id="element-2674">
                  {userData.name} is among the most active members of the
                  community
                </p>
                <button onClick={() => setShowImpactModal(true)} className="text-xs font-medium text-black hover:text-gray-700 transition-colors underline" data-id="element-2675">
                  Learn why
                </button>
              </div>
            </div>
            {showImpactDetails && <div className="mt-4 pt-4 border-t border-gray-200 animate-fade-in" data-id="element-2676">
                <p className="text-sm text-gray-600" data-id="element-2677">
                  This score reflects {userData.name}'s contribution through
                  event participation, collaborations with other members, and
                  knowledge sharing. Their proactive approach to networking has
                  created significant value for the entire community.
                </p>
              </div>}
          </div>
        </section>
        {/* Skills */}
        <section className="px-6 py-6 border-b border-gray-200" data-id="element-2678">
          <h2 className="text-xl font-sharp-grotesk mb-4" data-id="element-2679">Skills</h2>
          <p className="text-sm text-gray-600 mb-5" data-id="element-2680">{userData.experience}</p>
          <div className="space-y-6" data-id="element-2681">
            {/* Design Skills */}
            <div data-id="element-2682">
              <h3 className="text-base font-medium mb-3 flex items-center justify-between" data-id="element-2683">
                <span data-id="element-2684">Design Skills</span>
                <button onClick={() => toggleSection('designSkills')} className="text-gray-500 hover:text-black" data-id="element-2685">
                  {expandedSections.designSkills ? <ChevronDown className="w-5 h-5" data-id="element-2686" /> : <ChevronDown className="w-5 h-5" data-id="element-2687" />}
                </button>
              </h3>
              {expandedSections.designSkills && <div className="space-y-3" data-id="element-2688">
                  {userData.skills.designSkills.map((skill, index) => <div key={index} data-id="element-2689">
                      <div className="flex justify-between items-center mb-1" data-id="element-2690">
                        <span className="text-sm font-medium" data-id="element-2691">
                          {skill.name}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-2692">
                          {skill.expertise}
                        </span>
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2693">
                        <div className="bg-black h-1.5 rounded-full" style={{
                    width: skill.level
                  }} data-id="element-2694"></div>
                      </div>
                    </div>)}
                </div>}
            </div>
            {/* Research & Strategy */}
            <div data-id="element-2695">
              <h3 className="text-base font-medium mb-3 flex items-center justify-between" data-id="element-2696">
                <span data-id="element-2697">Research & Strategy</span>
                <button onClick={() => toggleSection('researchStrategy')} className="text-gray-500 hover:text-black" data-id="element-2698">
                  {expandedSections.researchStrategy ? <ChevronDown className="w-5 h-5" data-id="element-2699" /> : <ChevronDown className="w-5 h-5" data-id="element-2700" />}
                </button>
              </h3>
              {expandedSections.researchStrategy && <div className="space-y-3" data-id="element-2701">
                  {userData.skills.researchStrategy.map((skill, index) => <div key={index} data-id="element-2702">
                      <div className="flex justify-between items-center mb-1" data-id="element-2703">
                        <span className="text-sm font-medium" data-id="element-2704">
                          {skill.name}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-2705">
                          {skill.expertise}
                        </span>
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2706">
                        <div className="bg-black h-1.5 rounded-full" style={{
                    width: skill.level
                  }} data-id="element-2707"></div>
                      </div>
                    </div>)}
                </div>}
            </div>
            {/* Tools & Technologies */}
            <div data-id="element-2708">
              <h3 className="text-base font-medium mb-3 flex items-center justify-between" data-id="element-2709">
                <span data-id="element-2710">Tools & Technologies</span>
                <button onClick={() => toggleSection('toolsTechnologies')} className="text-gray-500 hover:text-black" data-id="element-2711">
                  {expandedSections.toolsTechnologies ? <ChevronDown className="w-5 h-5" data-id="element-2712" /> : <ChevronDown className="w-5 h-5" data-id="element-2713" />}
                </button>
              </h3>
              {expandedSections.toolsTechnologies && <div className="space-y-3" data-id="element-2714">
                  {userData.skills.toolsTechnologies.map((skill, index) => <div key={index} data-id="element-2715">
                      <div className="flex justify-between items-center mb-1" data-id="element-2716">
                        <span className="text-sm font-medium" data-id="element-2717">
                          {skill.name}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-2718">
                          {skill.expertise}
                        </span>
                      </div>
                      <div className="w-full bg-gray-100 rounded-full h-1.5" data-id="element-2719">
                        <div className="bg-black h-1.5 rounded-full" style={{
                    width: skill.level
                  }} data-id="element-2720"></div>
                      </div>
                    </div>)}
                </div>}
            </div>
          </div>
        </section>
        {/* AI Suggestions */}
        <section className="px-6 py-6 border-b border-gray-200" data-id="element-2721">
          <div className="flex justify-between items-center mb-4" data-id="element-2722">
            <h2 className="text-xl font-sharp-grotesk" data-id="element-2723">AI Analysis</h2>
            <div className="flex items-center bg-gray-100 rounded-full px-3 py-1" data-id="element-2724">
              <Zap className="w-4 h-4 text-yellow-500 mr-1" data-id="element-2725" />
              <span className="text-xs font-medium" data-id="element-2726">Powered by AI</span>
            </div>
          </div>
          <div className="space-y-4" data-id="element-2727">
            {userData.aiSuggestions.map((suggestion, index) => <div key={index} className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-2728">
                <div className="mb-2" data-id="element-2729">
                  <span className="text-2xl" data-id="element-2730">{suggestion.emoji}</span>
                </div>
                <h3 className="font-medium mb-2" data-id="element-2731">{suggestion.title}</h3>
                <p className="text-sm text-gray-600 mb-3" data-id="element-2732">
                  {suggestion.description}
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-2733">
                  {suggestion.tags.map((tag, tagIndex) => <span key={tagIndex} className="bg-gray-200 px-3 py-1 rounded-full text-xs" data-id="element-2734">
                      {tag}
                    </span>)}
                </div>
              </div>)}
          </div>
          <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-2735">
            <h3 className="text-base font-medium mb-2" data-id="element-2736">
              Potential collaborations
            </h3>
            <div className="space-y-4 mt-3" data-id="element-2737">
              {/* Profile archetype cards */}
              {userData.collaborations.map((collab, index) => <div key={index} className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2738">
                  <div className="flex-1 min-w-0" data-id="element-2739">
                    <div className="flex justify-between items-start" data-id="element-2740">
                      <div data-id="element-2741">
                        <h4 className="font-medium text-sm truncate" data-id="element-2742">
                          {collab.role}
                        </h4>
                        <p className="text-xs text-gray-500" data-id="element-2743">
                          Collaboration opportunity
                        </p>
                      </div>
                      <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full font-medium" data-id="element-2744">
                        {collab.match} match
                      </span>
                    </div>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-2745">
                      {collab.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Recent Events */}
        <section className="px-6 py-6 border-b border-gray-200" data-id="element-2746">
          <h2 className="text-xl font-sharp-grotesk mb-4" data-id="element-2747">Recent Events</h2>
          <p className="text-sm text-gray-600 mb-5" data-id="element-2748">
            The latest events {userData.name} has participated in within the
            community.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2749">
            <div className="bg-white rounded-lg overflow-hidden border border-gray-200" data-id="element-2750">
              <div className="relative overflow-hidden h-40 rounded-t-lg" data-id="element-2751">
                <img src="https://images.unsplash.com/photo-1558403194-611308249627?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Digital Marketing Meetup" className="w-full h-full object-cover" data-id="element-2752" />
                <div className="absolute top-2 right-2 bg-black text-white text-xs px-2 py-1 rounded-full" data-id="element-2753">
                  Participant
                </div>
              </div>
              <div className="p-4" data-id="element-2754">
                <p className="font-bold font-sharp-grotesk text-sm md:text-base mb-2" data-id="element-2755">
                  Digital Marketing Meetup
                </p>
                <div className="flex items-center text-gray-600 text-xs md:text-sm font-rubik" data-id="element-2756">
                  <span className="mr-3" data-id="element-2757">February 10, 2023</span>
                  <span data-id="element-2758">18:00 - 20:00</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5 text-center" data-id="element-2759">
            <button className="text-sm font-medium text-gray-500 flex items-center mx-auto hover:text-gray-700 transition-colors" data-id="element-2760">
              View all events
              <ChevronDown className="w-4 h-4 ml-1" data-id="element-2761" />
            </button>
          </div>
        </section>
        {/* Call to Action */}
        <section className="px-6 py-6" data-id="element-2762">
          <div className="bg-black text-white rounded-lg p-6 text-center" data-id="element-2763">
            <h3 className="text-xl font-sharp-grotesk mb-3" data-id="element-2764">
              Connect with {userData.name}
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-2765">
              Start a professional collaboration or exchange ideas on innovative
              projects.
            </p>
            <button className="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-colors" data-id="element-2766">
              <UserPlus className="w-4 h-4 inline-block mr-2" data-id="element-2767" />
              Send request
            </button>
          </div>
        </section>
      </div>
      {/* QR Code Modal */}
      {showQrModal && <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-2768">
          <div className="fixed inset-0 bg-black/60 transition-opacity" onClick={closeQrModal} data-id="element-2769"></div>
          <div className="bg-white p-6 rounded-lg z-10 max-w-md w-full mx-4 animate-fade-in" data-id="element-2770">
            <div className="flex justify-between items-center mb-4" data-id="element-2771">
              <h3 className="text-xl font-medium font-sharp-grotesk" data-id="element-2772">
                Profile QR Code
              </h3>
              <button onClick={closeQrModal} className="text-gray-500 hover:text-gray-700" data-id="element-2773">
                <X className="w-5 h-5" data-id="element-2774" />
              </button>
            </div>
            <div className="flex justify-center" data-id="element-2775">
              <div className="p-4 bg-white rounded-lg border border-gray-200" data-id="element-2776">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wSLHrp3Awu6TVmqA2nrc9U/images.png" alt="Profile QR Code" className="w-[200px] h-[200px]" data-id="element-2777" />
              </div>
            </div>
            <p className="text-center text-sm text-gray-600 mt-4" data-id="element-2778">
              Scan this QR code to share the profile
            </p>
          </div>
        </div>}
      {/* Impact Modal */}
      {showImpactModal && <div className="fixed inset-0 z-50 flex items-end justify-center" data-id="element-2779">
          <div className="fixed inset-0 bg-black/30" onClick={closeImpactModal} data-id="element-2780"></div>
          <div className="bg-white w-full rounded-t-xl overflow-hidden transform transition-all z-10 animate-slide-up" data-id="element-2781">
            <div className="p-6" data-id="element-2782">
              <div className="flex items-center justify-between mb-5" data-id="element-2783">
                <h3 className="text-xl font-medium font-sharp-grotesk" data-id="element-2784">
                  Impact Distribution
                </h3>
                <button onClick={closeImpactModal} className="text-gray-500 hover:text-gray-700" data-id="element-2785">
                  <X className="w-5 h-5" data-id="element-2786" />
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-6" data-id="element-2787">
                {userData.name}'s impact score is calculated based on several
                factors that reflect their contribution to the community. Here's
                how it breaks down:
              </p>
              <div className="space-y-5" data-id="element-2788">
                <div className="border border-gray-200 rounded-lg p-3" data-id="element-2789">
                  <div className="flex justify-between items-center mb-1" data-id="element-2790">
                    <h5 className="text-sm font-medium text-gray-700" data-id="element-2791">
                      Event Participation
                    </h5>
                    <span className="text-sm font-sharp-grotesk" data-id="element-2792">35%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-2793">
                    <div className="bg-black h-2 rounded-full" style={{
                  width: '35%'
                }} data-id="element-2794"></div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-lg p-3" data-id="element-2795">
                  <div className="flex justify-between items-center mb-1" data-id="element-2796">
                    <h5 className="text-sm font-medium text-gray-700" data-id="element-2797">
                      Collaborations
                    </h5>
                    <span className="text-sm font-sharp-grotesk" data-id="element-2798">28%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-2799">
                    <div className="bg-black h-2 rounded-full" style={{
                  width: '28%'
                }} data-id="element-2800"></div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-lg p-3" data-id="element-2801">
                  <div className="flex justify-between items-center mb-1" data-id="element-2802">
                    <h5 className="text-sm font-medium text-gray-700" data-id="element-2803">
                      Mentorship
                    </h5>
                    <span className="text-sm font-sharp-grotesk" data-id="element-2804">22%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-2805">
                    <div className="bg-black h-2 rounded-full" style={{
                  width: '22%'
                }} data-id="element-2806"></div>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-lg p-3" data-id="element-2807">
                  <div className="flex justify-between items-center mb-1" data-id="element-2808">
                    <h5 className="text-sm font-medium text-gray-700" data-id="element-2809">
                      Knowledge Sharing
                    </h5>
                    <span className="text-sm font-sharp-grotesk" data-id="element-2810">15%</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-2811">
                    <div className="bg-black h-2 rounded-full" style={{
                  width: '15%'
                }} data-id="element-2812"></div>
                  </div>
                </div>
              </div>
              <div className="mt-6 pt-5 border-t border-gray-200" data-id="element-2813">
                <p className="text-sm text-gray-600" data-id="element-2814">
                  {userData.name}'s proactive approach to networking and their
                  willingness to collaborate have created significant value for
                  the entire community.
                </p>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}